module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAQCAYAAABk1z2tAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4gEFDiI4GMgaHwAAAHdJREFUSMftzrsNwmAMAOFL/jxYi7loYDz2oKYEKfhiikSwAkh247Pk4us8c2ImckQOBI1gRiaCERkIps8dDJgzwYp0SI+47ey+jZj93rF1vva/hrng2jCfaMMYcbnjY8DbFY8XBLLnx6eABSxgAQtYwAIW8L+Bb4njQiBefUssAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/death-barrier.png
// module id = jgeE
// module chunks = 1